<template>
    <div class="container">
        <Header  :setupHeader="setupDataHeader"></Header>
        <div ref="containerScroll" class="container-scroll">

            <div class="container-content">
           
                <h3 class="main-title">
                    <img @click="router.push('/')" :src="leftArrow" alt="" />
                    {{ t('bat.maintitle') }}
                </h3>
                <div class="space"></div>
                <div class="full-img">
                    <video muted autoplay loop v-if="!isStreamAvailable">
                        <source :src="Podcetrtek_fallback" type="video/mp4">
                    </video>
                    <!--<img v-if="!isStreamAvailable" :src="podcetrtek1" alt="">-->
                    <video v-show="isStreamAvailable" muted id="videoElement"></video>
                    <p v-show="isStreamAvailable" class="video-sub">{{t('bat.livestream.caption')}}</p>
                    <div v-show="isStreamAvailable" class="caption">{{ t('bat.caption1.stream') }}</div>
                    <div v-show="!isStreamAvailable" class="caption">{{ t('bat.caption1') }}</div>
                </div>
            
                <section>
                    <div class="title">{{ t('bat.sec1_title') }}</div>
                    <div class="space"></div>
                    <div class="three-imgs">
                        <div class="img">
                            <video autoplay loop>
                                <source :src="nosferatu1" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div class="img">
                            <video autoplay loop>
                                <source :src="nosferatu2" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div class="img">
                            <video autoplay loop>
                                <source :src="nosferatu3" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                    <div class="space"></div>
                    <div class="full-img">
                        <img :src="podcetrtek3" alt="">
                        <div class="caption">{{ t('bat.caption2') }}</div>
                    </div>
                    <div class="space"></div>
                    <p>{{ t('bat.sec1_desc1') }}</p>
<br />
<p>{{ t('bat.sec1_desc2') }}</p>
                </section>
                <section>
                    <div class="title">{{ t('bat.sec2_title') }}</div>
                    <div class="space"></div>
                    <div class="three-imgs">
                        <div class="img">
                            <img :src="podcetrtek4" alt="">
                            <div class="caption">{{ t('bat.caption3') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek5" alt="">
                            <div class="caption">{{ t('bat.caption4') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek6" alt="">
                            <div class="caption">{{ t('bat.caption5') }}</div>
                        </div>
                    </div>
                    <div class="space"></div>
                    <p>{{ t('bat.sec2_desc1') }}</p>
<br />
<p>
    {{ t('bat.sec2_desc2') }}
</p>
                </section>
                <section>
                    <div class="title">{{ t('bat.sec3_title') }} </div>
                    <div class="space"></div>
                    <div class="three-imgs">
                        <div class="img">
                            <img :src="podcetrtek7" alt="">
                            <div class="caption">{{ t('bat.caption6') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek8" alt="">
                            <div class="caption">{{ t('bat.caption7') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek9" alt="">
                            <div class="caption">{{ t('bat.caption8') }}</div>
                        </div>
                    </div>
                    <div class="space"></div>
                    <p>{{ t('bat.sec3_desc1') }}
                    </p>    
                        <br />
                    <p>
                        {{ t('bat.sec3_desc2') }}
                    </p>
                </section>
                <section>
                    <div class="title">{{ t('bat.sec4_title') }}</div>
                    <div class="space"></div>
                    <p>
                        <b>
                            {{ t('bat.sec4_desc1') }}
                        </b>
                    </p>
                    <br />
                    <p>
                        {{  t('bat.sec4_desc2')  }}
                    </p>
                    <!--<div class="space"></div>
                    <div class="full-img">
                        <img :src="podcetrtek10" alt="">
                    </div>-->
                </section>
                <section>
                    <div class="title"> {{  t('bat.sec5_title')  }}</div>
                    <div class="space"></div>
                    <p><b>{{  t('bat.sec5_desc1')  }}</b></p>
                    <div class="space"></div>
                    <div class="three-imgs">
                        <div class="img">
                            <img :src="podcetrtek11" alt="">
                            <div class="caption">{{ t('bat.caption9') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek12" alt="">
                            <div class="caption">{{ t('bat.caption10') }}</div>
                        </div>
                        <div class="img">
                            <img :src="podcetrtek13" alt="">
                            <div class="caption">{{ t('bat.caption11') }}</div>
                        </div>
                    </div>
                </section>
                <div class="space"></div>
                <div class="space"></div>
                <div class="space"></div>
            </div>
            <div class="footer">
                <div class="holder">
                    <div class="btn" @click="router.push('/')">
                        <svg width="42" height="37" viewBox="0 0 42 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M38.625 11.1172C40.1855 11.1172 41.5625 12.4941 41.5625 14.0547V22.8672C41.5625 24.5195 40.1855 25.8047 38.625 25.8047H22.4688V33.1484C22.4688 34.8008 21.0918 36.0859 19.5312 36.0859C18.7051 36.0859 17.9707 35.8105 17.4199 35.2598L1.26367 20.5723C0.712891 20.0215 0.4375 19.2871 0.4375 18.4609C0.4375 17.7266 0.712891 16.9922 1.26367 16.4414L17.4199 1.75391C17.9707 1.20312 18.7051 0.835938 19.5312 0.835938C21.0918 0.835938 22.4688 2.21289 22.4688 3.77344V11.1172H38.625ZM38.625 22.8672V14.0547H19.5312V3.77344L3.375 18.4609L19.3477 33.0566L19.5312 22.8672H38.625Z" fill="#2E3D45"/>
                        </svg>
                        <div> {{ t('bat.backBtn') }}</div>
                    </div>
                    <svg class="logo" width="171" height="60" viewBox="0 0 171 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.07231 43.825C4.20055 43.6284 3.37546 43.4182 2.59702 43.1944C1.66437 42.9263 0.798698 42.6387 0 42.3315V45.234C0.901743 45.5721 1.89742 45.8727 2.98702 46.1357C4.09542 46.3987 5.32592 46.6054 6.67853 46.7556C7.09583 46.8071 7.52701 46.8507 7.97214 46.8865C8.98987 46.9683 10.0804 47.0093 11.2436 47.0093C11.2907 47.0093 11.3376 47.0091 11.3845 47.0089C13.8149 46.9957 16.0129 46.6418 17.9786 45.9472C17.9816 45.9461 17.9846 45.945 17.9876 45.944C18.043 45.9244 18.0983 45.9045 18.1533 45.8843C18.2553 45.8469 18.3568 45.8086 18.4576 45.7694C20.5804 44.924 22.2618 43.6747 23.5017 42.0215C24.7416 40.3495 25.3615 38.283 25.3615 35.822C25.3615 33.5864 24.8731 31.7736 23.8962 30.3834C22.9381 28.9932 21.5761 27.8472 19.8102 26.9455C18.0443 26.025 15.9402 25.1514 13.498 24.3248C11.4315 23.6297 9.63738 22.9158 8.11569 22.1831C6.61278 21.4505 5.44803 20.53 4.62143 19.4216C3.81362 18.3132 3.40972 16.8572 3.40972 15.0537C3.40972 13.3066 3.85119 11.8601 4.73415 10.7141C5.61711 9.56814 6.81004 8.71336 8.31294 8.14977C9.83464 7.56739 11.563 7.2762 13.498 7.2762C15.1136 7.2762 16.748 7.44528 18.4012 7.78343C19.6569 8.04028 20.9126 8.4055 22.1682 8.87911C22.5658 9.02904 22.9633 9.18983 23.3608 9.36149L24.3752 6.85351C23.8822 6.63501 23.3833 6.43321 22.8786 6.24813C22.5706 6.1352 22.2605 6.02849 21.9482 5.928C21.056 5.64094 20.1461 5.40464 19.2184 5.2191C17.4525 4.84338 15.5832 4.65551 13.6107 4.65551C11.1309 4.65551 8.89532 5.05942 6.90397 5.86723C4.93141 6.65626 3.36275 7.8304 2.198 9.38967C1.05203 10.9301 0.479051 12.837 0.479051 15.1101C0.479051 16.7633 0.732666 18.2004 1.2399 19.4216C1.76591 20.6239 2.51737 21.6571 3.49425 22.5213C4.47114 23.3667 5.64529 24.1181 7.01669 24.7757C8.40688 25.4144 9.94735 26.025 11.6381 26.6073C14.0616 27.4151 16.0717 28.2136 17.6685 29.0026C19.2654 29.7728 20.4583 30.7027 21.2473 31.7923C22.0551 32.8632 22.459 34.244 22.459 35.9347C22.459 37.8509 21.98 39.4384 21.0219 40.6971C20.0949 41.9148 18.8339 42.8336 17.2388 43.4535C17.1851 43.4743 17.1311 43.4949 17.0768 43.515C15.4236 44.135 13.5261 44.4449 11.3845 44.4449C11.3375 44.4449 11.2905 44.4448 11.2436 44.4447C10.1921 44.4407 9.17694 44.3922 8.19821 44.2993C7.11135 44.1961 6.06938 44.038 5.07231 43.825ZM34.5246 6.82309C34.5253 6.82384 34.5261 6.82459 34.5268 6.82533C34.6304 6.92995 34.7492 7.00622 34.8576 7.05076C34.8793 7.05966 34.8983 7.0664 34.9144 7.07148C34.9202 7.07331 34.9256 7.07493 34.9305 7.07635C34.9575 7.06984 34.9964 7.05822 35.0444 7.03779C35.1568 6.98989 35.2663 6.91575 35.3575 6.82533C35.3583 6.82449 35.3592 6.82365 35.36 6.8228C35.2544 6.70966 35.127 6.62504 35.0066 6.57598C34.9776 6.56418 34.9527 6.55591 34.9327 6.55015C34.927 6.55203 34.9209 6.55412 34.9144 6.55646C34.9081 6.5587 34.9016 6.56117 34.8947 6.56388C34.7823 6.60802 34.6446 6.69308 34.5246 6.82309ZM79.7155 17.9295C80.991 18.2174 82.0726 18.818 82.9604 19.7315C84.2566 21.0654 84.9047 23.1506 84.9047 25.9874V46.4457H87.6945V25.8747C87.6945 22.1925 86.8397 19.4967 85.1302 17.7871C83.8387 16.4956 82.1934 15.692 80.1943 15.3762C79.5471 15.2739 78.8629 15.2228 78.1417 15.2228C78.0377 15.2228 77.9344 15.2237 77.8317 15.2256C75.5035 15.2674 73.5028 15.7831 71.8295 16.7727C70.9769 17.2824 70.234 17.8904 69.6009 18.5966C69.5431 18.6611 69.4862 18.7264 69.4302 18.7925C69.4301 18.7926 69.4301 18.7927 69.43 18.7928C68.8724 19.4515 68.4055 20.1915 68.0294 21.0128C68.0186 21.0365 68.0078 21.0603 67.9971 21.0841H67.7998C67.7891 21.0496 67.7782 21.0152 67.7672 20.9809C67.7184 20.8295 67.6666 20.6811 67.612 20.5356C67.3174 19.7515 66.9378 19.0542 66.4731 18.4437C65.9516 17.7587 65.323 17.1829 64.5873 16.7163C63.5455 16.0346 62.3451 15.5863 60.9862 15.3713C60.3604 15.2723 59.7009 15.2228 59.0078 15.2228C58.8846 15.2228 58.7624 15.2242 58.6415 15.227C57.1032 15.2626 55.7506 15.5242 54.5836 16.0118C53.886 16.3078 53.2507 16.6544 52.678 17.0515C52.6719 17.0557 52.6659 17.0598 52.6599 17.064C52.2858 17.3247 51.9385 17.607 51.6179 17.911C51.5631 17.963 51.509 18.0157 51.4557 18.0689C50.6145 18.9101 49.9408 19.8257 49.4344 20.8156C49.4319 20.8206 49.4293 20.8256 49.4268 20.8305H49.2577L48.835 15.8146H46.5243V46.4457H49.3704V28.6926C49.3704 26.6395 49.6241 24.8845 50.1315 23.4276C50.2416 23.1114 50.3636 22.8094 50.4976 22.5213C50.6436 22.2038 50.8017 21.9025 50.9718 21.6176C51.1839 21.2623 51.4148 20.9323 51.6644 20.6277C51.7189 20.5613 51.7742 20.4961 51.8304 20.4321C52.1449 20.074 52.4874 19.7536 52.8578 19.471C53.1271 19.2655 53.4112 19.0799 53.7101 18.9143C54.261 18.6017 54.8517 18.3509 55.4823 18.1622C55.4863 18.161 55.4903 18.1598 55.4944 18.1586C56.4517 17.8734 57.5008 17.7308 58.6415 17.7308C58.765 17.7308 58.8871 17.733 59.0078 17.7375C59.5353 17.7572 60.0359 17.8198 60.5097 17.9254C61.1807 18.0749 61.7979 18.3106 62.3612 18.6325C63.4132 19.2149 64.2304 20.1167 64.8128 21.3378C65.4139 22.5401 65.7145 24.09 65.7145 25.9874V46.4457H68.5325V28.2981C68.5325 26.5289 68.7251 24.9899 69.1102 23.6812C69.3011 23.0325 69.5393 22.4403 69.8248 21.9048C70.1499 21.2949 70.5363 20.7583 70.9841 20.2951C71.5798 19.6791 72.2573 19.174 73.0166 18.7799C73.0198 18.7782 73.0231 18.7765 73.0264 18.7748C74.3719 18.0788 75.9737 17.7308 77.8317 17.7308C77.936 17.7308 78.0394 17.7324 78.1417 17.7356C78.6955 17.7531 79.2201 17.8177 79.7155 17.9295ZM113.504 18.0382C115.447 18.5101 116.989 19.5254 118.128 21.0841C119.782 23.3197 120.608 26.5885 120.608 30.8906C120.608 33.7837 120.214 36.2447 119.425 38.2736C118.636 40.3026 117.49 41.8524 115.987 42.9232C115.343 43.3818 114.637 43.7422 113.87 44.0044C112.915 44.3306 111.864 44.5048 110.717 44.527C110.633 44.5287 110.549 44.5295 110.464 44.5295C109.116 44.5295 107.9 44.349 106.817 43.9881C106.804 43.9839 106.792 43.9796 106.779 43.9754C106.094 43.7441 105.463 43.4403 104.884 43.0641C104.605 42.8806 104.339 42.6794 104.086 42.4607C104.081 42.4561 104.075 42.4514 104.07 42.4467C103.624 42.0586 103.217 41.6154 102.852 41.1173C102.744 40.9698 102.639 40.8175 102.538 40.6604C102.41 40.4614 102.287 40.2548 102.171 40.0404C101.934 39.6054 101.721 39.1386 101.531 38.64C101.476 38.491 101.423 38.3392 101.372 38.1846C100.745 36.2733 100.432 33.9359 100.432 31.1724V30.6933C100.448 28.324 100.723 26.2684 101.257 24.5266C101.35 24.2244 101.451 23.9317 101.559 23.6485C101.698 23.2894 101.851 22.9466 102.017 22.6199C102.161 22.3368 102.314 22.0658 102.478 21.807C102.59 21.6299 102.707 21.4584 102.828 21.2926C103.194 20.7934 103.602 20.3458 104.052 19.9498C104.34 19.6962 104.646 19.4638 104.969 19.2525C105.585 18.8465 106.263 18.5218 107.003 18.2783C108.112 17.9133 109.359 17.7308 110.745 17.7308C110.869 17.7308 110.991 17.7324 111.112 17.7355C111.967 17.7577 112.765 17.8586 113.504 18.0382ZM103.804 17.4847C103.806 17.4834 103.808 17.4821 103.809 17.4808C104.475 16.9648 105.228 16.5221 106.068 16.1527C107.388 15.5719 108.947 15.2631 110.745 15.2265C110.866 15.224 110.988 15.2228 111.112 15.2228C112.154 15.2228 113.134 15.3153 114.052 15.5003C116.608 16.0153 118.68 17.2472 120.27 19.1961C122.449 21.845 123.539 25.7525 123.539 30.9188C123.539 34.3755 123.022 37.3061 121.989 39.7108C120.956 42.0966 119.481 43.9095 117.565 45.1494C116.677 45.7296 115.705 46.174 114.648 46.4827C113.447 46.8337 112.137 47.0093 110.717 47.0093C110.632 47.0093 110.548 47.0087 110.464 47.0075C108.728 46.9835 107.207 46.7117 105.898 46.1921C105.068 45.8462 104.323 45.4297 103.663 44.9424C103.66 44.9398 103.656 44.9372 103.653 44.9347C103.418 44.7611 103.194 44.5785 102.981 44.387C102.864 44.2814 102.75 44.173 102.639 44.0619C102.598 44.0209 102.557 43.9795 102.517 43.9377C101.615 42.9796 100.92 41.9276 100.432 40.7816H100.234C100.236 40.809 100.237 40.8364 100.239 40.8638C100.258 41.2267 100.275 41.5949 100.292 41.9684C100.313 42.4303 100.332 42.9003 100.349 43.3786C100.358 43.6285 100.367 43.8806 100.375 44.135C100.39 44.595 100.402 45.0448 100.411 45.4844C100.425 46.1577 100.432 46.8068 100.432 47.432V60H97.5573V15.8146H99.9244L100.263 21.9295H100.432C100.433 21.9263 100.434 21.9231 100.436 21.92C100.943 20.7588 101.655 19.6629 102.573 18.6325C102.607 18.5948 102.641 18.5574 102.675 18.5203C103.019 18.1473 103.395 17.8021 103.804 17.4847ZM140.82 23.9091C139.916 24.2979 139.045 24.7885 138.223 25.381V2.58489C143.005 -0.861628 149.455 -0.861628 154.238 2.58489C158.198 5.43896 163.302 5.92956 167.655 4.0567C168.559 3.66793 169.43 3.17733 170.252 2.58489V25.381C165.47 28.8275 159.02 28.8275 154.238 25.381C150.277 22.5269 145.173 22.0363 140.82 23.9091ZM140.82 21.1225C145.76 19.3834 151.353 20.1007 155.756 23.2741C159.282 25.8154 163.928 26.0444 167.655 23.9611V6.84336C162.715 8.58239 157.122 7.86518 152.719 4.69174C149.193 2.15046 144.547 1.92146 140.82 4.00474V21.1225ZM33.3927 5.13456C33.0545 5.54786 32.8854 6.11145 32.8854 6.82533C32.8854 7.53921 33.0545 8.1028 33.3927 8.5161C33.7308 8.9294 34.2381 9.13605 34.9144 9.13605C35.6282 9.13605 36.1543 8.9294 36.4924 8.5161C36.8306 8.1028 36.9996 7.53921 36.9996 6.82533C36.9996 6.11145 36.8306 5.54786 36.4924 5.13456C36.1543 4.70248 35.6282 4.48644 34.9144 4.48644C34.2381 4.48644 33.7308 4.70248 33.3927 5.13456ZM131.936 46.4457V2.59841H134.811V46.4457H131.936ZM36.2952 15.8146H33.449V46.4457H36.2952V15.8146Z" fill="#fff"/>
                    </svg>
                    <div @click="scrollToTop()" class="btn">{{ t('bat.topBtnFooter') }}</div>
                </div>
            </div>
            <div v-show="scrollPosition > 6300" class="back-to-top"  @click="scrollToTop()">
                <div class="text">{{ t('bat.topBtn') }}</div>
                <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41016 11.1562L11.2539 0.843749C11.5469 0.550781 11.8984 0.374999 12.3086 0.374999C12.6602 0.374999 13.0117 0.55078 13.3047 0.843749L23.1484 11.1562C23.6758 11.6836 23.6758 12.6211 23.0898 13.1484C22.5625 13.6758 21.625 13.6758 21.0977 13.0898L13.7148 5.29687L13.7148 25.2187C13.7148 26.0391 13.0703 26.625 12.3086 26.625C11.4883 26.625 10.9023 26.0391 10.9023 25.2187L10.9023 5.29687L3.46094 13.0898C2.93359 13.6758 1.99609 13.6758 1.46875 13.1484C0.882812 12.6211 0.882812 11.7422 1.41016 11.1562Z" fill="#2E3D45"/>
                </svg>
            </div>
        </div>
    </div>
</template>
<script setup>
import Header from '@/components/Header.vue'
import { ref,onMounted,onUnmounted } from "vue";
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import leftArrow from "@/assets/presentation/left-arrow.svg";
import podcetrtek1 from "@/assets/podcetrtek/1.jpg";
import podcetrtek2 from "@/assets/podcetrtek/bats-video.mp4";
import podcetrtek3 from "@/assets/podcetrtek/3.jpg";
import podcetrtek4 from "@/assets/podcetrtek/4.jpg";
import podcetrtek5 from "@/assets/podcetrtek/5.jpg";
import podcetrtek6 from "@/assets/podcetrtek/6.jpg";
import podcetrtek7 from "@/assets/podcetrtek/7.jpg";
import podcetrtek8 from "@/assets/podcetrtek/8.jpg";
import podcetrtek9 from "@/assets/podcetrtek/9.jpg";
import podcetrtek10 from "@/assets/podcetrtek/10.jpg";
import podcetrtek11 from "@/assets/podcetrtek/11.png";
import podcetrtek12 from "@/assets/podcetrtek/12.png";
import podcetrtek13 from "@/assets/podcetrtek/13.png";
import nosferatu1 from "@/assets/podcetrtek/nosferatu1.mp4";
import nosferatu2 from "@/assets/podcetrtek/nosferatu2.mp4";
import nosferatu3 from "@/assets/podcetrtek/nosferatu3.mp4";
import mpegts from 'mpegts.js';
import Podcetrtek_fallback from '@/assets/podcetrtek/Podcetrtek_fallback.mp4';

const setupDataHeader = {
  centerIcon: true,
  orderFilter: false,
  search: false,
  backArrow: false,
  backArrowMap: true,
}

const containerScroll = ref(null);
const router = useRouter();
const scrollPosition = ref(0);
const isStreamAvailable = ref(false);
const player = ref(null);

const { t } = useI18n();

const scrollToTop = () => {
  const duration = 500; // Duration in milliseconds
  const start = containerScroll.value.scrollTop;
  const startTime = performance.now();

  // Easing function for smooth animation
  const easeInOutQuad = (time, from, distance, duration) => {
    time /= duration / 2;
    if (time < 1) return distance / 2 * time * time + from;
    time--;
    return -distance / 2 * (time * (time - 2) - 1) + from;
  };

  // Animation loop
  const animateScroll = (currentTime) => {
    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, start, -start, duration);
    containerScroll.value.scrollTop = run;

    if (timeElapsed < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      containerScroll.value.scrollTop = 0;
    }
  };

  requestAnimationFrame(animateScroll);
};

onMounted(() => {
  if (containerScroll.value) {
    containerScroll.value.addEventListener('scroll', handleScroll);
  }

  if (mpegts.getFeatureList().mseLivePlayback) {
        console.log('MSE Live Playback supported, attempting to connect to stream...');
        let lastDecodedFrames = 0;
        var videoElement = document.getElementById('videoElement');
        
        if (!videoElement) {
          console.error('Video element not found');
          return;
        }

        player.value = mpegts.createPlayer({
            type: 'flv',  // could also be mpegts, m2ts, flv
            isLive: true,
            url: 'ws://192.168.1.119:8000/live/netopirji.flv'
        });

        player.value.attachMediaElement(videoElement);
        
        // Add more event listeners for debugging
        player.value.on(mpegts.Events.LOADING_COMPLETE, () => {
          console.log('Stream loading completed');
        });

        player.value.on(mpegts.Events.MEDIA_INFO, (mediaInfo) => {
          console.log('Media info received:', mediaInfo);
        });

        player.value.on(mpegts.Events.METADATA_ARRIVED, (metadata) => {
          console.log('Metadata arrived:', metadata);
        });

        player.value.on(mpegts.Events.SCRIPTDATA_ARRIVED, (data) => {
          console.log('Script data arrived:', data);
        });

        player.value.on(mpegts.Events.STATISTICS_INFO, (stats) => {
          console.log('Stream stats:', stats);
          if (!isStreamAvailable.value && stats.speed > 0 && stats.decodedFrames > 0) {
            console.log('Stream is now available, switching to live stream');
            isStreamAvailable.value = true;
          } else if (isStreamAvailable.value && (stats.speed === 0 || stats.decodedFrames === lastDecodedFrames)) {
            console.log('Stream appears to be stalled, switching to fallback');
            isStreamAvailable.value = false;
          }
          
          lastDecodedFrames = stats.decodedFrames;
        });

        player.value.on(mpegts.Events.ERROR, (errorType, errorDetail) => {
          console.error('Stream error:', errorType, errorDetail);
          isStreamAvailable.value = false;
        });

        player.value.on(mpegts.Events.DESTROYING, () => {
          console.log('Player is being destroyed');
        });

        // Load and play with error handling
        try {
          player.value.load();
          player.value.play().then(() => {
            console.log('Stream playback started successfully');
          }).catch((error) => {
            console.error('Failed to start playback:', error);
            isStreamAvailable.value = false;
          });
        } catch (error) {
          console.error('Error loading stream:', error);
          isStreamAvailable.value = false;
        }
    } else {
        console.log('MSE Live Playback not supported, using fallback video');
    }
});

onUnmounted(() => {
  if (containerScroll.value) {
    containerScroll.value.removeEventListener('scroll', handleScroll);
  }
  
  // Clean up the player
  if (player.value) {
    console.log('Destroying player on component unmount');
    player.value.destroy();
    player.value = null;
  }
});

const handleScroll = () => {
  scrollPosition.value = containerScroll.value.scrollTop;
};

</script>
<style scoped lang="scss">
@import '../../assets/style/mixins.scss';
#videoElement {
    width: 100%;
    margin: 0 auto;
    display: block;
}
.back-to-top {
    display: flex;
    position:fixed;
    bottom:get-vw(300px);
    right:get-vw(-40px);
    font-size: get-vw(30px);
    background-color: #fff;
    padding:get-vw(3px) get-vw(30px);
    font-weight: 400;
    font-family:"RobotoFlex";
    transform: rotate(-90deg);
    align-items: center;
    border-radius: get-vw(65px);
    border:get-vw(2px) solid #2E3D45;

    svg {
        width:get-vw(25px);
        height:get-vw(25px);
        transform: rotate(90deg);
        margin-left: get-vw(16px);
    }
}
.container-scroll {
    width:100%;
    height: calc(100vh - 6.25vw);
    overflow-y: scroll;
}
.container{
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
    position: relative;
}
.container-content {
    max-width:get-vw(1465px);
    margin:0 auto;
    width:100%;
    color:#000;
    height:auto;
    font-family:"RobotoFlex";
    .main-title {
        color: #2E3D45;
        font-size: get-vw(47px);
        font-weight: 500;
        display: inline-block;
        img {
            width:get-vw(42px);
        }
        &:after {
            content:"";
            display:block;
            width: get-vw(550px);
            height: get-vw(8px);
            margin-top: get-vw(20px);
            background-color: #2E3D45;
        }
    }
    .full-img {
        padding:0 get-vw(10px);
        position: relative;
        img {
            width:100%;
            display: block;
        }
        .caption {
            margin-top:get-vw(25px);
            font-size: get-vw(20px);
            font-weight: 300;
            font-family:"RobotoFlex";
            font-style: italic;
        }
        .video-sub {
            position: absolute;
            font-size: get-vw(20px);
            font-weight: 300;
            font-family:"RobotoFlex";
            font-style: italic;
            bottom:get-vw(64px);
            right:0;
            background-color: #fff;
            border-radius: 25px;
            padding-right: get-vw(40px);
            padding-top:get-vw(5px);
            padding-bottom:get-vw(5px);
        }
    }
    .full-video {
        video {
            width:100%;
            display: block;
        }
        .caption {
            margin-top:get-vw(25px);
            font-size: get-vw(20px);
            font-weight: 300;
            font-family:"RobotoFlex";
            font-style: italic;
        }
    }
}

section {
    margin-top: get-vw(170px);

    .title {
        color: #2E3D45;
        font-size: get-vw(40px);
        font-weight: 400;
        display: inline-block;
        &:after {
            content:"";
            display:block;
            width: get-vw(550px);
            height: get-vw(8px);
            margin-top: get-vw(20px);
            background-color: #2E3D45;
        }
    }
    .three-imgs {
        width: 100%;
        display: flex;
        gap:get-vw(30px);
        padding:0 get-vw(10px);
        .img {
            img {
                width:get-vw(464px);
            }
            video {
                width:get-vw(464px);
            }
        .caption {
            margin-top:get-vw(25px);
            font-size: get-vw(20px);
            font-family:"RobotoFlex";
            font-style: italic;
        }
        }
    }
}
.footer {
    background-color: #2E3D45;
    padding:get-vw(30px) 0;
    .holder {
        display: flex;
        width:100%;
        margin:0 auto;
        max-width:get-vw(1455px);
        display: flex;
        justify-content: space-between;
        .btn {
            border-radius: get-vw(50px);
            font-family: "RobotoFlex";
            background-color: #fff;
            display: flex;
            font-weight: 500;
            justify-content: center;
            align-items: center;
            font-size: get-vw(30px);
            color:#2E3D45;
            padding:get-vw(10px) get-vw(20px);
            svg {
                margin-right: get-vw(15px);
                width:get-vw(35px);
                height:get-vw(35px);
            }
            div {
                font-weight: 500;
            }
        }
        .logo {
            height:get-vw(60px);
        }
    }
}
.space {
    height: get-vw(60px);
}

p{
    font-family:"RobotoFlex";
    font-size: get-vw(20px);
    font-weight: 400;
    padding: 0 get-vw(10px);
}

@media only screen and (orientation: portrait) {
    .container-scroll {
        height: calc(100vh - 11.75vw);
    }

}
</style>